'use client';

import FormCheckbox from '@/components/form/FormCheckbox/FormCheckbox';
import FormText from '@/components/form/FormText/FormText';
import FaIcon, { faSearch } from '@/components/icon/FaIcon/FaIcon';
import PageHeader from '@/components/layouts/PageHeader/PageHeader';
import utilsStyles from '@/styles/modules/utils.module.scss';
import type { Route } from 'next';
import { useRouter } from 'next/navigation';
import { useForm } from 'react-hook-form';
import type { Keyword } from '../../types';
import styles from './LotteryListHeader.module.scss';

function LotteryListHeader({
  query,
  isSession = false,
}: {
  query?: string;
  keywords: Array<Keyword>;
  activeKeywordId?: number;
  isSession?: boolean;
}) {
  const router = useRouter();
  const { handleSubmit, getValues, control } = useForm({
    mode: 'onChange',
    defaultValues: {
      session: isSession ? ['session'] : [],
      searchText: query || '',
    },
  });

  const onChangeCheck = () => {
    const params = new URLSearchParams(location.search);
    if (getValues('session').length > 0) {
      params.set('session', String(true));
    } else {
      params.delete('session');
    }
    router.replace(`${location.pathname}?${params.toString()}` as Route);
  };

  const textSearch = () => {
    const params = new URLSearchParams(location.search);
    if (getValues('searchText').length > 0) {
      params.set('q', getValues('searchText'));
    } else {
      params.delete('q');
    }
    router.replace(`${location.pathname}?${params.toString()}` as Route);
  };

  const onChangeText = () => {
    textSearch();
  };

  const submitText = async () => {
    textSearch();
  };

  return (
    <>
      <div className={styles.header}>
        <PageHeader text='オンラインくじ一覧' />
        <div className={styles.textSearchWrapper}>
          <form onSubmit={handleSubmit(submitText)}>
            <FormText
              name='searchText'
              control={control}
              outlined
              placeholder='イベント名を検索できます'
              prefix={
                <div className={styles.searchIcon}>
                  <FaIcon icon={faSearch} size='xl' />
                </div>
              }
              onChange={onChangeText}
              isSmall={true}
            />
          </form>
        </div>
      </div>

      <div className={styles.searchArea}>
        {query && (
          <div className={utilsStyles.mtXSmall}>
            <p className={`${utilsStyles.textSmall} ${utilsStyles.textBold}`}>"{query}"の検索結果</p>
          </div>
        )}
        <div className={styles.searchAreaSession}>
          <FormCheckbox
            name='session'
            items={[
              {
                value: 'session',
                child: <>開催中のイベントのみを表示</>,
              },
            ]}
            control={control}
            onChange={onChangeCheck}
          />
        </div>
      </div>
    </>
  );
}

export default LotteryListHeader;
